export default __webpack_public_path__ + "static/media/newmoblogo.bf2bce40.svg";